import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

var _this = this;

import _ from 'lodash';
import CreativeInfo from './index.vue';
import CreativeInfoDialog from './dialog.vue';
import { getGmakerProjectInfo } from '@pt/api/gmaker/project.js';

export default {
  name: 'editCreativeInfo.vue',

  props: {
    id: {
      type: Number,
      required: true
    },

    // 作品类型，枚举值 'normal', 'playsmart', 'free', 'iv
    type: {
      type: String,
      default: 'normal',
      validator: function validator(value) {
        return ['normal', 'playsmart', 'free', 'iv'].indexOf(value) !== -1;
      }
    },

    action: {
      type: String,
      default: 'update',
      validator: function validator(value) {
        return ['update', 'copy'].indexOf(value) !== -1;
      }
    },

    dialog: {
      type: Object
    },

    readMode: {
      type: Boolean,
      default: false
    },

    schema: {
      type: Object
    },

    fetchProjectInfo: {
      type: Function
    },

    /**
     * 更新信息接口
     */
    updateRequest: {
      type: Function
    },

    createRequest: {
      type: Function
    },

    beforeOpen: {
      type: Function,
      default: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt('return', true);

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function _default() {
          return _ref.apply(this, arguments);
        };
      }()
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  components: {
    CreativeInfo: CreativeInfo,
    CreativeInfoDialog: CreativeInfoDialog
  },

  data: function data() {
    return {
      dialogVisible: false,
      creativeInfo: {},
      loading: false
    };
  },


  computed: {
    innerDialog: function innerDialog() {
      var _this2 = this;

      return _extends({
        // eslint-disable-next-line consistent-return
        beforeClose: function beforeClose(done) {
          if (!_this2.loading) return done();
        }
      }, this.dialog);
    }
  },

  watch: {
    dialogVisible: function dialogVisible() {
      var ref = this.$refs['creative-info'];
      if (ref) {
        ref.form.resetFields();
        ref.form.clearValidate();
      }
    }
  },

  mounted: function mounted() {},


  methods: {
    open: function open() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this3.disabled) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                _context2.next = 4;
                return _this3.beforeOpen();

              case 4:
                res = _context2.sent;

                if (!res) {
                  _context2.next = 10;
                  break;
                }

                _this3.dialogVisible = true;
                _context2.next = 9;
                return _this3.getCreativeInfo(_this3.id);

              case 9:
                _this3.creativeInfo = _context2.sent;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    close: function close() {
      this.dialogVisible = false;
    },
    handleUpdateSuccess: function handleUpdateSuccess() {
      this.$emit('update-success');
      this.close();
    },
    getCreativeInfo: function getCreativeInfo(id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var postData, res, apps, name, promotedType, iOSApp, androidApp, getPlatform, info;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                postData = { project_id: id };

                if (!_this4.fetchProjectInfo) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 4;
                return _this4.fetchProjectInfo(postData);

              case 4:
                _context3.t0 = _context3.sent;
                _context3.next = 10;
                break;

              case 7:
                _context3.next = 9;
                return getGmakerProjectInfo(postData);

              case 9:
                _context3.t0 = _context3.sent;

              case 10:
                res = _context3.t0;

                console.log(res);
                apps = _.get(res, 'data.data.apps') || [];
                name = _.get(res, 'data.data.name') || '';
                promotedType = _.get(res, 'data.data.promoted_type') || '';
                iOSApp = apps.find(function (app) {
                  return app.platform === 'ios';
                }) || {};
                androidApp = apps.find(function (app) {
                  return app.platform === 'android';
                }) || {};

                getPlatform = function getPlatform() {
                  if (iOSApp.platform && androidApp.platform) {
                    return 'ios,android';
                  }
                  if (iOSApp.platform && !androidApp.platform) {
                    return 'ios';
                  }
                  if (!iOSApp.platform && androidApp.platform) {
                    return 'android';
                  }
                  return '';
                };

                info = {
                  name: _this4.action === 'copy' ? name + '_copy' : name,
                  orientation: _.get(res, 'data.data.orientation') || '',
                  platform: getPlatform(),
                  promotedType: promotedType,

                  iOSAppUrl: iOSApp.app_url || '',
                  iOSAppIcon: iOSApp.app_icon || '',
                  iOSAppName: iOSApp.app_name || '',
                  iOSAppUrlInSystem: iOSApp.in_system === 1,

                  androidAppUrl: androidApp.app_url || '',
                  androidAppIcon: androidApp.app_icon || '',
                  androidAppName: androidApp.app_name || '',
                  androidAppUrlInSystem: androidApp.in_system === 1
                };


                if (promotedType === 'website') {
                  info.appUrl = iOSApp.app_url || androidApp.app_url || '';
                  info.appIcon = iOSApp.app_icon || androidApp.app_icon || '';
                  info.appName = iOSApp.app_name || androidApp.app_name || '';
                  info.appUrlInSystem = iOSApp.in_system === 1 || androidApp.in_system === 1;
                }

                return _context3.abrupt('return', info);

              case 21:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  }
};